const e = {
  name: "Microphone2",
  dimensions: { width: 24, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 40" style="enable-background:new 0 0 24 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M12,0C7.6,0,4,3.6,4,8v12c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8V8C20,3.6,16.4,0,12,0z M6,8c0-3.3,2.7-6,6-6
			c3.3,0,6,2.7,6,6h-4v2h4v3h-4v2h4v3h-4v2h4c0,3.3-2.7,6-6,6c-3.3,0-6-2.7-6-6h4v-2H6v-3h4v-2H6v-3h4V8H6z"/>
		<path class="st0" d="M12,30C6.5,30,2,25.5,2,20H0c0,6.3,4.8,11.5,11,12v6H6v2h12v-2h-5v-6c6.2-0.5,11-5.7,11-12h-2
			C22,25.5,17.5,30,12,30z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Microphone2
};
